import FolderIcon from "@mui/icons-material/Folder";
import FileIcon from "@mui/icons-material/InsertDriveFile";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { defaultStyles } from "react-file-icon";
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import {
  refreshSublistEntries,
  enterToDirectorySublist,
  refreshFileListSublist,
  setSelectedFolderSublist,
} from "../../../../../state/slices/file_manager";
import "../File.scss";

const FileSublist = (props) => {
  const { type, name } = props;
  const dispatch = useDispatch();

  const isSelected = useSelector(
    (state) =>
      state.fileManager.selectedFolderSublist &&
      state.fileManager.selectedFolderSublist.name === name
  );

  const handleClick = (event) => {
    event.stopPropagation();
    dispatch(setSelectedFolderSublist({ name, type }));
  };

  const handleDoubleClick = async (event) => {
    event.stopPropagation();
    await dispatch(refreshSublistEntries(props.name));
    dispatch(enterToDirectorySublist(name));
    dispatch(refreshFileListSublist());
    dispatch(setSelectedFolderSublist(null));
  };

  return (
    <div
      className="File"
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      data-selected={isSelected}
    >
      <ListItem>
        <ListItemAvatar>
          <Avatar
            variant="square"
            sx={{
              width: 40,
              height: 48,
              bgcolor: "transparent",
              borderRadius: 0,
            }}
          >
            {type === "dir" ? (
              <FolderIcon sx={{ fontSize: 40, color: "#F4D03F" }} />
            ) : (
              <FileIcon
                extension={name.split(".").pop()}
                {...(defaultStyles[name.split(".").pop()] || {})}
              />
            )}
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={name} secondary="" />
      </ListItem>
    </div>
  );
};

export default FileSublist;
